document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
    if (format && format.includes('{{amount_no_decimals}}')) return format.replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100).toLocaleString('en-US'));
    if (format && format.includes('{{amount}}')) return format.replace('{{amount}}', Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    return `৳${Number(amount).toLocaleString('en-US')}`;
  };

  const deliveryGroup = document.querySelector('[data-delivery-options]');
  const deliveryChargeEl = document.querySelector('[data-delivery-charge]');
  const estimatedTotalEl = document.querySelector('[data-estimated-total]');
  const notice = document.querySelector('[data-delivery-message]');

  const refreshDeliveryEstimate = () => {
    if (!deliveryGroup || !deliveryChargeEl || !estimatedTotalEl) return;
    const selected = deliveryGroup.querySelector('input:checked')?.value || 'Inside Dhaka';
    const inside = Number(deliveryGroup.dataset.insideCharge || 8000);
    const outside = Number(deliveryGroup.dataset.outsideCharge || 12000);
    const charge = selected === 'Inside Dhaka' ? inside : selected === 'Outside Dhaka' ? outside : 0;
    const subtotal = Number(estimatedTotalEl.dataset.cartTotal || 0);
    const moneyFormat = deliveryGroup.dataset.moneyFormat || '৳{{amount}}';
    deliveryChargeEl.textContent = charge === 0 ? 'Free' : formatMoney(charge, moneyFormat);
    estimatedTotalEl.textContent = formatMoney(subtotal + charge, moneyFormat);
    if (notice) notice.textContent = `${selected} selected • Estimated delivery: ${charge === 0 ? 'Free' : formatMoney(charge, moneyFormat)}. Final checkout charge follows your Shopify shipping settings.`;
  };

  document.querySelectorAll('.mp-choice input, .mp-payment input').forEach((input) => {
    input.addEventListener('change', () => {
      const group = input.closest('.mp-choice-list, .mp-payment-grid');
      if (group) {
        group.querySelectorAll('.mp-choice, .mp-payment').forEach((card) => card.classList.remove('is-selected'));
        input.closest('.mp-choice, .mp-payment')?.classList.add('is-selected');
      }
      if (input.name === 'attributes[Delivery Area]') refreshDeliveryEstimate();
    });
  });
  refreshDeliveryEstimate();

  const button = document.querySelector('[data-apply-discount]');
  const input = document.querySelector('#MarketplaceDiscountCode');
  const message = document.querySelector('[data-discount-message]');
  if (button && input) button.addEventListener('click', () => {
    const code = input.value.trim();
    if (!code) { if (message) { message.hidden = false; message.textContent = 'Enter a coupon code first.'; } return; }
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`);
  });
});
